"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextWithHtml = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const TextWithHtml = exports.TextWithHtml = (0, _mui.styled)(_presentationComponents.TextWithHtml)(({
  theme
}) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  li: {
    listStylePosition: 'inside'
  }
}));
